import routerOptions0 from "/codebuild/output/src239773520/src/gx-booking/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_en_a1a286f120b921cfb9afba8203a11c0f/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}